export enum AVAILABLE_ENVS {
  PROD = 'Production',
  STAGING = 'Staging',
  QA = 'QA',
  DEV = 'Develop',
  LOCAL = 'Local'
}
